<template>
	<div class="header">
		<div class="logo">
			<img alt="" src="../../assets/images/logoNoWords.png">
			<span>国家高端智能化家用电器创新中心</span>
		</div>
		<div class="menu">
			<el-menu
					:default-active="activeIndex"
					class="el-menu-demo"
					mode="horizontal"
					text-color="#333">
				<el-menu-item index="0" @click="$router.push('/index')">首页</el-menu-item>
<!--        <el-submenu index="1" :popper-append-to-body="false">-->
<!--          <template slot="title">数字赋能</template>-->
<!--          <el-menu-item v-for="(item, index) in list" :key="index" index="2-1" @click="goPath(item)">{{-->
<!--              item.name-->
<!--            }}-->
<!--          </el-menu-item>-->
<!--        </el-submenu>-->
				<template v-for="(item, index) in menuList">
					<el-submenu v-if="item.urlFlag == 2" :key="index" :index="String(index + 2)" :popper-append-to-body="false" >
						<template slot="title">{{ item.name }}</template>
						<template v-if="item.detailList && item.detailList.length">
							<el-menu-item v-for="(ite, index) in item.detailList" :key="index" @click="goPath(ite)">
								{{ ite.name }}
							</el-menu-item>
						</template>
					</el-submenu>
					<el-menu-item v-else :key="index" :index="String(index + 2)" @click="goPath(item)">{{ item.name }}</el-menu-item>
				</template>

				<!--        <el-submenu index="2" :popper-append-to-body="false">-->
				<!--          <template slot="title">数字赋能</template>-->
				<!--          <el-menu-item v-for="(item, index) in list" :key="index" index="2-1" @click="goPath(item)">{{-->
				<!--              item.name-->
				<!--            }}-->
				<!--          </el-menu-item>-->
				<!--        </el-submenu>-->
				<!--        <el-menu-item index="3">大模型平台</el-menu-item>-->
				<!--        <el-menu-item index="4" @click="goLink()">关于国创</el-menu-item>-->
			</el-menu>
			<!--      <el-autocomplete-->
			<!--          v-model="state"-->
			<!--          :fetch-suggestions="querySearch"-->
			<!--          :trigger-on-focus="false"-->
			<!--          class="inline-input"-->
			<!--          placeholder="搜索关键词"-->
			<!--          @select="searchSelect"-->
			<!--      >-->
			<!--        <i-->
			<!--            slot="prefix"-->
			<!--            class="el-icon-search el-input__icon">-->
			<!--        </i>-->
			<!--      </el-autocomplete>-->
			<el-select
					class="inline-input"
					v-model="search"
					filterable
					remote
					placeholder="请输入关键词"
					:remote-method="querySearch"
					@change="searchSelect"
					:loading="loading">
				<i
						slot="prefix"
						class="el-icon-search el-input__icon">
				</i>
				<el-option
						v-for="item in searchOptions"
						:key="item.clientId"
						:label="item.name"
						:value="item.clientId">
				</el-option>
			</el-select>
		</div>
		<!-- <el-tooltip class="item" effect="dark" content="一体化服务平台管理入口" placement="bottom"> -->

		<!-- </el-tooltip> -->
    <div class="platEnter">
      <div style="display: flex;align-items: center;cursor:pointer;margin-right: 14px" @click="goBasePlate()">
        <img src="@/assets/images/sys.png" style="width: 18px;height: 18px;">
        <span style="font-size: 14px;color: #333;margin-left: 5px" >一体化服务平台管理入口</span>
      </div>
      <div v-if="showReportEnter" style="display: flex;align-items: center;cursor:pointer;" @click="goReport()">
        <img src="@/assets/images/visitNew/pie.png" style="width: 18px;height: 18px;">
        <span style="font-size: 14px;color: #333;margin-left: 5px" >指标报表</span>
      </div>
    </div>
		<div class="loginWrapper">
			<div class="notLogin" @click="login" v-show="!isLogin">
				登录/注册
			</div>
		</div>
	</div>
</template>

<script>
import {getSectorPlateForm, menuList, saveLogBuriedPoint} from '@/api/viewIndex';
import localUrl from '@/axios/localUrl';
import {goLogin} from '@/utils/judge';

export default {
	name: 'Header',
	data() {
		return {
			fits: ['none'],
			activeIndex: '1',
			search: '',
			list: [],
			menuList: [],
			isLogin: false,
			searchOptions: [],
			loading: false,
      showReportEnter: false
		};
	},
	created() {
		this.getSectorPlateForm();
		this.getMenuList();
	},
	mounted() {
		// setTimeout(() => {
		const token = sessionStorage.getItem('token_portalUI');
    const userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}')
		if (token) {
			this.isLogin = true;
      const hasBarometer = (userInfo.baseRoleList || []).find(item=>item.roleCode === 'barometer')

      // if (['00950675', '00053316','01452147','01499303','01508387'].includes(userInfo.jobNumber)) {
      //   this.showReportEnter = true
      // }
      if(hasBarometer){
        this.showReportEnter = true
      }
		}
		// }, 2000)
	},
	methods: {
    goReport() {
      this.$router.push('/visitsStatisticsReport');
    },
		goBasePlate(){
			window.open("http://10.247.237.140:81/gczx/login/platform")
		},
		querySearch(string, cb) {
			console.log(string);
			this.loading = true;
			getSectorPlateForm({
				name: string,
			})
					.then((res) => {
						this.searchOptions = res.data.result || [];
					})
					.catch(err => {
						console.log(err);
					})
					.finally(() => {
						this.loading = false;
					});
		},
		searchSelect(ite) {
			const token = sessionStorage.getItem('token_portalUI');
			if (!token) {
				goLogin();
				return;
			}
			const userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}');
			const obj = userInfo.baseClientVo?.find(item => item.clientId === ite);
			if (!obj) {
				this.$message.warning('无访问权限');
				return;
			}
			if (obj && ite.url) {
				// this.$router.push(obj.visitUrl)
				window.open(ite.url, '_blank');
			} else {
				this.$message.warning('无访问地址');
			}
		},
		getSectorPlateForm() {
			getSectorPlateForm({})
					.then((res) => {
						this.list = res.data.result || [];
					})
					.catch(err => {
						console.log(err);
					});
		},
		getMenuList() {
			menuList().then(res => {
				console.log(res, 'getMenuList');
				this.menuList = res.data.result || [];
			}).catch(err => {
				console.log(err);
			});
		},
		login() {
			goLogin();
			// window.location.href = 'https://auth-test.gczx.com:8443/service/logout?redirect_uri=' + localUrl.redirectUrl
		},
		goPath(ite) {
			const userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}');
			const token = sessionStorage.getItem('token_portalUI');
			console.log('185 => ite', ite);
			if (ite.urlFlag == 1) {
				if (!token) {
					goLogin();
					return;
				}
				console.log(ite, userInfo);
				const obj = userInfo.baseClientVo?.find(item => item.clientId === ite.clientId);
				if (!obj) {
					this.$message.warning('无访问权限');
					return;
				}
				if (obj && ite.url) {
					// this.$router.push(obj.visitUrl)
					window.open(ite.url, '_blank');
				} else {
					this.$message.warning('无访问地址');
				}
				this.savePoint(ite)
			} else {
				if (!ite.url) {
					this.$message.warning('无直接跳转地址');
					return
				}
				window.open(ite.url, '_blank');
			}

		},
		goLink() {
			window.location.href = 'https://www.gczx.cn/';
		},
		savePoint(item) {
			const userInfo = JSON.parse(sessionStorage.getItem('userInfo_portalUI') || '{}')
			const data = {
				userName: this.user.nickName || userInfo.nickName,
				userId: this.user.userId || userInfo.userId,
				userPhone: this.user.mobile || userInfo.mobile,
				channel: 'A01',
				behaviorAttribute: '1',
				behaviorAttributeValue: '1',
				ip: this.$globalIP || '',
				clientCode: item.clientId,
				clientName: item.name,
				sectorInfoId: item.id,
				remark: JSON.stringify(sessionStorage.getItem('userInfo_portalUI'))
			}
			saveLogBuriedPoint(data).then(res => {
				console.log(res);
			}).catch(err => {})
		}
	},
};
</script>

<style lang="scss" scoped>
$headerHeight: 80px;
$white: #ffffff;
.header {
	width: 100%;
	height: $headerHeight;
	background: #ffffff;
	display: flex;
	align-items: center;

	.logo {
		margin: 0 40px;
		width: auto;
		display: flex;
		align-items: center;

		img {
			height: 65px;
			width: auto;
		}

		span {
			display: inline-block;
			font-size: 16px;
			font-weight: 600;
			color: #0074c0;
			margin-left: 10px;
			white-space: nowrap;
		}
	}

	.menu {
		width: 100%;
		display: flex;
		align-items: center;

		.inline-input {
			margin-left: 30px;

			::v-deep .el-input__inner {
				background-color: #ECECEE;
			}
		}
	}

	.loginWrapper {
		margin-left: auto;
		height: 100%;

		.notLogin {
			width: 150px;
			height: $headerHeight;
			line-height: $headerHeight;
			color: $white;
			background: #297FFD;
			cursor: pointer;
			text-align: center;
		}
	}
}
.platEnter {
  display: flex;
  white-space: nowrap;
  position: relative;
  right: 55px;
}
::v-deep .el-menu--horizontal > .el-menu-item,
::v-deep .el-menu--horizontal > .el-submenu .el-submenu__title {
	height: $headerHeight;
	line-height: $headerHeight;
}

::v-deep .el-menu.el-menu--horizontal {
	border: none;
}

::v-deep .el-menu.el-menu--popup {
	max-height: 300px;
	overflow: auto;
}
</style>
